'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconAnalyticsPieAlt = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M10.5 24A10.512 10.512 0 0 0 21 13.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 0-.5-.5 10.5 10.5 0 0 0 0 21z' }),
    _react2.default.createElement('path', { d: 'M13.5 0a.5.5 0 0 0-.5.5V10a1 1 0 0 0 1 1h9.5a.5.5 0 0 0 .5-.5A10.512 10.512 0 0 0 13.5 0z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M10.5 24C4.71 24 0 19.29 0 13.5S4.71 3 10.5 3a.5.5 0 0 1 .5.5V13h9.5a.5.5 0 0 1 .5.5C21 19.29 16.29 24 10.5 24zM10 4.013c-4.986.263-9 4.465-9 9.487 0 5.238 4.262 9.5 9.5 9.5 5.021 0 9.224-4.014 9.487-9H11c-.551 0-1-.448-1-1V4.013z' }),
    _react2.default.createElement('path', { d: 'M14 11c-.552 0-1-.449-1-1V.5a.5.5 0 0 1 .5-.5C19.29 0 24 4.71 24 10.5a.5.5 0 0 1-.5.5H14zm0-1h8.987A9.492 9.492 0 0 0 14 1.013V10z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M13.5 11.25a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75c5.376 0 9.75 4.374 9.75 9.75a.75.75 0 0 1-.75.75h-9zm8.216-1.5c-.359-3.929-3.537-7.107-7.466-7.466V9.75h7.466z' }),
    _react2.default.createElement('path', { d: 'M10.5 23.25c-5.376 0-9.75-4.374-9.75-9.75s4.374-9.75 9.75-9.75a.75.75 0 0 1 .75.75v8.25h8.25a.75.75 0 0 1 .75.75c0 5.376-4.374 9.75-9.75 9.75zM9.75 5.284a8.229 8.229 0 0 0-7.5 8.216c0 4.549 3.701 8.25 8.25 8.25 4.3 0 7.837-3.264 8.216-7.5H10.5a.75.75 0 0 1-.75-.75V5.284z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconAnalyticsPieAlt.displayName = 'IconAnalyticsPieAlt';
exports.default = IconAnalyticsPieAlt;